import { APIDebt, Debt, DebtStatus } from "../types";

const SORTING_MAP = {
  emittedDate: "emitted_date",
  dueDate: "due_date",
  originalAmount: "original_amount",
  remainingAmount: "remaining_amount",
  invoiceNumber: "invoice_number",
  description: "description",
  status: "status",
  contactName: "contact",
  branchName: "branch",
};

export const mapAPIDebtToDebt = (apiDebt: APIDebt): Debt => {
  return {
    contactName: apiDebt.contact.name,
    originalAmount: apiDebt.original_amount,
    remainingAmount: apiDebt.remaining_amount,
    emittedDate: apiDebt.emitted_date,
    dueDate: apiDebt.due_date,
    companyId: apiDebt.company_id,
    orgId: apiDebt.org_id,
    status: apiDebt.status,
    createdAt: apiDebt.created_at,
    updatedAt: apiDebt.updated_at,
    invoiceNumber: apiDebt.invoice_number,
    description: apiDebt.description,
    id: apiDebt.id,
    type: apiDebt.type,
    tags: apiDebt.tags,
    contactId: apiDebt.contact_id,
    branchName: apiDebt.branch?.name,
    branch: apiDebt.branch,
    tax: apiDebt.tax,
    category: apiDebt.category,
    department: apiDebt.department,
    images: apiDebt.images?.map((image) => ({
      id: image.id,
      image_url: image.image_url,
      presigned_url: image.presigned_url ?? "",
      content_type: image.content_type ?? "",
    })),
    approvalStatus: apiDebt.approval_status,
  };
};

export const toDebtsBackendSorting = (sortBy: string | undefined) => {
  if (sortBy && sortBy in SORTING_MAP) {
    return SORTING_MAP[sortBy as keyof typeof SORTING_MAP];
  } else {
    return undefined;
  }
};

export const getDebtStatusLabel = (status: DebtStatus) => {
  switch (status) {
    case DebtStatus.PENDING:
      return "Pendiente";
    case DebtStatus.PARTIALLY_PAID:
      return "Pago parcial";
    case DebtStatus.PAID:
      return "Pagado";
    case DebtStatus.OVERDUE:
      return "Vencido";
    case DebtStatus.CANCELLED:
      return "Cancelado";
    default:
      return "";
  }
};

export const getDebtStatusColor = (status: DebtStatus) => {
  switch (status) {
    case DebtStatus.PENDING:
      return "#2196F3";
    case DebtStatus.PARTIALLY_PAID:
      return "#FFC107";
    case DebtStatus.PAID:
      return "#4CAF50";
    case DebtStatus.OVERDUE:
      return "#F44336";
    case DebtStatus.CANCELLED:
      return "#9E9E9E";
    default:
      return "";
  }
};
